import { AxiosRequestConfig } from 'axios';
import { request } from './';

export const login = (config?: AxiosRequestConfig) => {
    return request<{ access: string; refresh: string }>({
        url: '/token/',
        method: 'post',
        ...config
    });
};

export const userInfo = (config?: AxiosRequestConfig) => {
    return request<{ user_id: number }>({
        url: '/user_id/',
        method: 'get',
        ...config
    });
};

// export const logout = (config?: AxiosRequestConfig) => {
//     return request({
//         url   : '/api/logout/',
//         method: 'post',
//         ...config
//     });
// };
